module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Mic-7ffab457df88b10e805ca8fa430c55a1.svg";